
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/choose",
      function () {
        return require("private-next-pages/account/choose.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/choose"])
      });
    }
  